import axios from 'axios';
import { getSpeakerBasicHeaders } from '../../common/utils/utils';

const {
    Aborter,
    BlobURL,
    BlockBlobURL,
    ContainerURL,
    ServiceURL,
    StorageURL,
    AnonymousCredential,
    uploadBrowserDataToBlockBlob,
} = require("@azure/storage-blob");


const generateFileName = (fileName, url) => {
    let name = fileName;
    if (fileName.includes(url)) {
        if (fileName.includes('speakerpresentation')) {
            name = name.replace(`${url}/speakerpresentation/`, '');
        } else if (fileName.includes('speakerprofileimages')) {
            name = name.replace(`${url}/speakerprofileimages/`, '');
        }
    }
    return name;
};

const getStorageSASToken = async (id, baseURL) => {
    return new Promise((resolve, reject) => {
        axios({
            url: `${baseURL}speaker/api/speaker/get/sas/${id}`,
            headers: getSpeakerBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                reject(err);
            });
    });
};

export const uploadFileToBlobStorage = async (mediaFile, fileName, baseURL, SASTokenId) => {
    const file = mediaFile;
    const SasKeyObj = await getStorageSASToken(SASTokenId, baseURL);
    const Container = SasKeyObj.containerName;
    const SasKey = SasKeyObj.token;
    const BlobUrl = SasKeyObj.url;

    const anonymousCredential = new AnonymousCredential();
    const pipeline = StorageURL.newPipeline(anonymousCredential);

    const serviceURL = new ServiceURL(
        `${BlobUrl}/${SasKey}`,
        pipeline,
    );

    const containerURL = ContainerURL.fromServiceURL(serviceURL, Container);


    const content = file;
    const blobName = generateFileName(fileName, BlobUrl);
    const blobURL = BlobURL.fromContainerURL(containerURL, blobName);
    const blockBlobURL = BlockBlobURL.fromBlobURL(blobURL);


    return new Promise((resolve, reject) => {
        if (file.type.includes('image')) {
            //this is for file upload
            const uploadBlobResponse = blockBlobURL.upload(
                Aborter.none,
                content,
                content.size,
            );

            uploadBlobResponse
                .then((response) => {
                    console.log(`Upload block blob ${blobName} successfully`);
                    resolve(response);
                })
                .catch((err) => {
                    console.log('errored');
                    reject(err);
                });
        } else {
            const singleShot = 1024 * 1024 * 10;

            const videoUpload = uploadBrowserDataToBlockBlob(
                Aborter.none,
                content,
                blockBlobURL,
                {
                    blockSize: singleShot,
                    progress: () => { console.log('working on uploading your file'); }, //we will use this later to show percent complete
                    parallelism: 4,
                },
            );

            videoUpload
                .then(() => {
                    console.log(`Video blob ${blobName} successfully`);
                    //changing to return the new filename so we can use later
                    resolve({ newVideoUrl: `${BlobUrl}/${Container}/${blobName}` });
                })
                .catch((err) => {
                    console.log('errored video');
                    reject(err);
                });
        }
    });
};
